import { ApolloClient, InMemoryCache, InMemoryCacheConfig, from } from '@apollo/client';
import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import { relayStylePagination } from '@apollo/client/utilities';

import { errorLink } from './links/error-link';
import { httpLink } from './links/http-link';
import { retryLink } from './links/retry-link';
import { roundTripLink } from './links/round-trip-link';
import { scalarsLink } from './links/scalars-link';

import possibleTypesResult from '../../../graphql/schema';
import { urlBuilder } from '../../../Shared/urlBuilder';

if (process.env.NODE_ENV !== 'production') {
  loadDevMessages();
  loadErrorMessages();
}

export const InMemoryCacheOptions: InMemoryCacheConfig = {
  possibleTypes: possibleTypesResult.possibleTypes,
  typePolicies: {
    Query: {
      fields: {
        activityConnection: relayStylePagination(),
      },
    },
  },
};

export const client = new ApolloClient({
  link: from([retryLink, errorLink, roundTripLink, scalarsLink, httpLink(urlBuilder.apiGraphQL(), {})]),
  cache: new InMemoryCache(InMemoryCacheOptions),
  connectToDevTools: true,
  defaultOptions: {
    query: {
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
    },
    mutate: {
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
    },
    watchQuery: {
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    },
  },
});
